import { useState, useEffect } from "react";

const options = {
  Text: {
    type: "Text",
    inputType: "text",
    mask: null,
    name: "Text",
  },
  Number: {
    type: "Number",
    inputType: "Number",
    mask: null,
    name: "Number",
  },
  Email: {
    type: "Text",
    inputType: "email",
    mask: null,
    name: "Email",
  },
  Password: {
    type: "Text",
    inputType: "password",
    mask: null,
    name: "Password",
  },
  "US Date": {
    type: "Date",
    inputType: "text",
    mask: "99/99/9999",
    maskPlaceHolder: "mm/dd/yyyy",
    name: "US Date",
  },
  "US Phone": {
    type: "Text",
    inputType: "text",
    mask: "(999) 999-9999",
    maskPlaceHolder: "",
    name: "US Phone",
  },
  "Credit Card": {
    type: "Text",
    inputType: "text",
    mask: "9999 9999 9999 9999",
    maskPlaceHolder: "",
    name: "Credit Card",
  },
};
export default function ({ value, onChange }) {
  const [_value, setValue] = useState("");

  useEffect(() => {
    if (value) {
      setValue(value.name);
    } else {
      setValue("Text");
    }
  }, [value]);

  const handleChange = (e) => {
    onChange(options[e.target.value]);
  };

  return (
    <div>
      <select value={_value} onChange={handleChange} className="dropdown">
        {Object.keys(options).map((key) => {
          return <option value={key}>{key}</option>;
        })}
      </select>
    </div>
  );
}
